<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6 @click="clearCache">设备列表<i class="fas fa-sync-alt ms-2" style="cursor: pointer;"></i></h6>
        <div class="d-flex align-items-center gap-2">
          <input
            v-model="searchBoardId"
            type="text"
            class="form-control form-control-sm"
            placeholder="设备ID"
            style="width: 150px;"
          />
          <input
            v-model="searchDeliverId"
            type="number"
            class="form-control form-control-sm"
            placeholder="商户ID"
            style="width: 120px;"
          />
          <select v-model="searchOnline" class="form-select form-select-sm" style="width: 120px;">
            <option value="-1">全部状态</option>
            <option value="1">在线</option>
            <option value="0">离线</option>
          </select>
          <button class="btn btn-sm btn-outline-primary" @click="doSearch">搜索</button>
          <button class="btn btn-sm btn-outline-secondary" @click="resetSearch" v-if="hasSearch">重置</button>
        </div>
        <button
          type="button"
          class="btn btn-primary btn-sm mb-0"
          :disabled="selectedBoardIds.length === 0"
          @click="openFotaModal"
        >
          升级固件
        </button>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                选择
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                设备ID
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                隶属商户
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                状态
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                入网时间
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                外设信息
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                固件版本
              </th>
              <th class="text-secondary opacity-7">操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="device in paginatedDevices" :key="device.board_id">
            <tr>
              <td class="align-middle text-center">
                <div class="form-check d-flex justify-content-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="device.board_id"
                    v-model="selectedBoardIds"
                  />
                </div>
              </td>
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="deviceImg"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                  alt="device-avatar"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                <h6 class="mb-0 text-sm">ID: {{ device.board_id }}</h6>
                <p class="text-xs text-secondary mb-0">{{ device.board_name || '未命名' }}</p>
                <p class="text-xs text-secondary mb-0">{{ device.board_type_name }}</p>
                  </div>
                </div>
              </td>
              <td>
            <p class="text-xs font-weight-bold mb-0">{{ getDeliverDisplayName(device) }}</p>
            <p class="text-xs text-secondary mb-0">{{ getDeliverLocation(device) }}</p>
              </td>
          <td class="align-middle text-center text-sm">
            <soft-badge
              :color="device.online === 1 ? 'success' : 'danger'"
              variant="gradient"
              size="sm"
            >
              {{ device.online === 1 ? '当前在线' : '当前离线' }}
            </soft-badge>
          </td>
          <!-- 入网时间 -->
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {{ formattedDate(device.date) }}
            </span>
          </td>
          <!-- 外设信息 -->
          <td class="align-middle text-center">
            <span v-if="device.sub_device_count > 0" class="text-xs font-weight-bold text-primary" style="cursor: pointer;" @click="toggleSubDeviceExpand(device.board_id)">
              {{ device.sub_device_count }} 个
              <br>
              <span class="text-xs text-secondary">{{ device.sub_device_types?.join(', ') || '-' }}</span>
              <br>
              <span class="text-xs text-info" style="text-decoration: underline;">{{ expandedBoardIds.includes(device.board_id) ? '收起详情' : '查看详情' }}</span>
            </span>
            <span v-else class="text-xs text-secondary">-</span>
          </td>
          <!-- 固件版本 -->
          <td class="align-middle text-center">
            <span class="text-xs text-secondary font-weight-bold">{{ device.firmware_version || '-' }}</span>
          </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="test coin"
                  @click="openTestCoinModal(device.board_id, device.online, device)"
                  >测试投币</a
                >
                <span class="mx-2 text-secondary">|</span>
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="uart config"
                  @click="openUartModal(device)"
                  >串口配置</a
                >
                <span class="mx-2 text-secondary">|</span>
                <a
                  href="javascript:;"
                  class="text-danger font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="remote reboot"
                  @click="handleReboot(device)"
                  >远程重启</a
                >
                <span class="mx-1 text-secondary">|</span>
                <a
                  href="javascript:;"
                  class="text-warning font-weight-bold text-xs"
                  @click="handlePowerCtrl(device)"
                  >开关机</a
                >
                <span class="mx-1 text-secondary">|</span>
                <a
                  href="javascript:;"
                  class="text-info font-weight-bold text-xs"
                  @click="handleBindHistory(device)"
                  >历史</a
                >
              </td>

              <!-- Test Coin Modal -->
              <div
                v-if="isModalVisible"
                class="modal fade show"
                style="display: block; padding-right: 17px;"
                tabindex="-1"
                role="dialog"
                aria-labelledby="testCoinModalLabel"
                aria-hidden="false"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="testCoinModalLabel">请输入投币数量</h5>
                      <!-- <h5 class="modal-title" id="testModelPort">请输入端口号</h5> -->
                    </div>
                    <div class="modal-body">
                      <input
                        v-model="coinCount"
                        type="number"
                        class="form-control"
                        placeholder="请输入投币数量"
                        min="1"
                      />
                      <input
                        v-model="port"
                        type="number"
                        class="form-control"
                        placeholder="请输入端口号"
                        min="1"
                      />
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="closeModal">取消</button>
                      <button type="button" class="btn btn-primary" @click="submitTestCoin">确认</button>
                    </div>
                  </div>
                </div>
              </div>

            </tr>
            <!-- 外设折叠展开行 -->
            <tr v-if="expandedBoardIds.includes(device.board_id)" :key="'sub_' + device.board_id">
              <td colspan="8" class="p-0">
                <div class="p-3 bg-light">
                  <div v-if="!device.sub_devices || device.sub_devices.length === 0" class="text-center text-secondary py-3">
                    暂无外设数据
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table table-sm align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-xs text-secondary">端口</th>
                          <th class="text-xs text-secondary">序列号</th>
                          <th class="text-xs text-secondary">设备型号</th>
                          <th class="text-xs text-secondary">设备类型</th>
                          <th class="text-xs text-secondary text-end">货道数</th>
                          <th class="text-xs text-secondary text-end">列数</th>
                          <th class="text-xs text-secondary text-end">能力掩码</th>
                          <th class="text-xs text-secondary">固件版本</th>
                          <th class="text-xs text-secondary text-center">状态</th>
                          <th class="text-xs text-secondary">绑定时间</th>
                          <th class="text-xs text-secondary">最后上报</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="sd in (device.sub_devices || [])" :key="sd.uart_port + '_' + (sd.serial_number || 'n/a')">
                          <td class="text-xs font-weight-bold">串口{{ sd.uart_port }}</td>
                          <td class="text-xs font-monospace">{{ sd.serial_number || '未绑定' }}</td>
                          <td class="text-xs">{{ sd.device_model || '-' }}</td>
                          <td class="text-xs">{{ sd.device_type_name || '未上报' }}</td>
                          <td class="text-xs text-end">{{ sd.channel_count || 0 }}</td>
                          <td class="text-xs text-end">{{ sd.column_count || 0 }}</td>
                          <td class="text-xs text-end">{{ sd.capability_mask ?? '-' }}</td>
                          <td class="text-xs">{{ sd.firmware_version || '-' }}</td>
                          <td class="text-center">
                            <span :class="(device.online === 1 && sd.status === 1) ? 'badge bg-success' : (sd.serial_number ? 'badge bg-warning text-dark' : 'badge bg-secondary')">
                              {{ (device.online === 1 && sd.status === 1) ? '在线' : (sd.serial_number ? '离线' : '未绑定') }}
                            </span>
                          </td>
                          <td class="text-xs">{{ sd.bound_at ? formattedDate(sd.bound_at) : '-' }}</td>
                          <td class="text-xs">{{ sd.last_report_at ? formattedDate(sd.last_report_at) : '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            </template>

          </tbody>
        </table>
      </div>
      <div
        v-if="isFotaModalVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="fotaModalLabel"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="fotaModalLabel">升级固件</h5>
            </div>
            <div class="modal-body">
              <div class="mb-3 text-sm">
                当前选择设备ID：{{ selectedBoardIdsText }}
              </div>
              <!-- OSS升级 -->
              <div class="mb-3">
                <label class="form-label text-sm fw-bold">OSS方式升级</label>
                <input
                  v-model="fotaOssName"
                  type="text"
                  class="form-control"
                  placeholder="请输入升级包oss_name"
                />
                <div class="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    :disabled="fotaSubmitting"
                    @click="confirmOssFota"
                  >
                    确认升级
                  </button>
                </div>
              </div>
              <hr />
              <!-- URL升级 -->
              <div class="mb-2">
                <label class="form-label text-sm fw-bold">URL方式升级</label>
                <input
                  v-model="fotaUrl"
                  type="text"
                  class="form-control"
                  placeholder="请输入盒子支付URL，如 https://pay.abc.com/gateway"
                />               
                <div class="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    :disabled="fotaSubmitting"
                    @click="confirmUrlFota"
                  >
                    确认升级
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeFotaModal">取消</button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isUartModalVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="uartConfigModalLabel"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="uartConfigModalLabel">串口配置</h5>
            </div>
            <div class="modal-body">
              <div class="mb-2 text-sm">
                设备ID：{{ uartBoardId || '未选择' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                当前端口：{{ currentUartConfig ? currentUartConfig.uart_port || '未上报' : '未上报' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                当前波特率：{{ currentUartConfig ? currentUartConfig.uartport_baud_rate || '未上报' : '未上报' }}
              </div>
              <div class="mb-3 text-sm text-secondary">
                上次更新时间：{{ currentUartConfig ? formattedDate(currentUartConfig.updated_date || 0) : '未上报' }}
              </div>
              <input
                v-model="uartForm.uartPort"
                type="number"
                class="form-control mb-2"
                placeholder="指定端口号（可选）"
                min="0"
              />
              <input
                v-model="uartForm.baudrate"
                type="number"
                class="form-control mb-2"
                placeholder="指定波特率"
                min="1"
              />
              <input
                v-model="uartForm.baudrateList"
                type="text"
                class="form-control"
                placeholder="批量端口波特率，如 0:115200,1:9600"
              />
              <div class="text-xs text-secondary mt-2">
                批量输入优先于单端口设置
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeUartModal">取消</button>
              <button type="button" class="btn btn-outline-primary" :disabled="uartRefreshCooling" @click="refreshUartConfig">
                {{ uartRefreshCooling ? '请稍后' : '刷新配置' }}
              </button>
              <button type="button" class="btn btn-primary" @click="submitUartConfig">保存设置</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 添加分页控件 -->
      <div class="d-flex justify-content-between align-items-center px-4 py-3">
        <div class="text-sm text-gray-700">
          显示 {{ startIndex + 1 }} - {{ endIndex }} 条，共 {{ totalDevices }} 条
        </div>
        <div class="flex-shrink-0">
          <nav aria-label="Page navigation">
            <ul class="pagination pagination-sm mb-0">
              <!-- 上一页按钮 -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                  <i class="fas fa-chevron-left"></i>
                </a>
              </li>
              
              <!-- 页码按钮 -->
              <li v-for="page in displayedPages" 
                  :key="page" 
                  class="page-item"
                  :class="{ active: page === currentPage }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">
                  {{ page }}
                </a>
              </li>
              
              <!-- 下一页按钮 -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                  <i class="fas fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import { mapActions, mapGetters } from "vuex";
import { formatDate } from "@/utils/dateformat";
import { getMerchantInfoMap } from "@/utils/merchantCache";

export default {
  name: "device-table",
  data() {
    return {
      deviceImg: require("../../assets/img/device.png"),

      // 搜索/筛选
      searchBoardId: '',
      searchDeliverId: '',
      searchOnline: '-1',

      isModalVisible: false,
      coinCount: 1,
      selectedBoardId: null,
      selectedBoardIds: [],
      isFotaModalVisible: false,
      fotaOssName: "",
      fotaUrl: "",
      fotaSubmitting: false,
      isUartModalVisible: false,
      uartBoardId: "",
      uartForm: {
        uartPort: "",
        baudrate: "",
        baudrateList: "",
      },
      uartRefreshCooling: false,
      uartRefreshTimer: null,
      // 外设折叠展开
      expandedBoardIds: [],
      // 商户信息映射
      merchantInfoMap: {},
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
  },
  computed:{
    ...mapGetters('boards', ['getAllDevices', 'getUartConfigByBoardId', 'getPagination']),
    devices(){
      return this.getAllDevices;
    },
    pagination() {
      return this.getPagination;
    },
    paginatedDevices() {
      return this.devices;
    },
    currentUartConfig() {
      if (!this.uartBoardId) {
        return null;
      }
      return this.getUartConfigByBoardId(this.uartBoardId);
    },
    selectedBoardIdsText() {
      if (this.selectedBoardIds.length === 0) {
        return "未选择设备";
      }
      return this.selectedBoardIds.join(", ");
    },
    // 总页数
    totalPages() {
      return this.pagination.totalPages || 1;
    },
    // 当前页码
    currentPage() {
      return this.pagination.currentPage || 1;
    },
    // 每页数量
    pageSize() {
      return this.pagination.pageSize || 20;
    },
    // 总记录数
    totalDevices() {
      return this.pagination.totalCount || 0;
    },
    // 计算起始索引
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    // 计算结束索引
    endIndex() {
      return Math.min(this.startIndex + this.pageSize, this.totalDevices);
    },
    // 计算要显示的页码
    displayedPages() {
      const displayPageCount = 5;
      let start = Math.max(1, this.currentPage - Math.floor(displayPageCount / 2));
      let end = start + displayPageCount - 1;
      
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, end - displayPageCount + 1);
      }
      
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    hasSearch() {
      return this.searchBoardId || this.searchDeliverId || this.searchOnline !== '-1';
    }
  },
  methods: {
    ...mapActions('boards', ['fetchDevices', 'clearLocalCache', 'fetchUartConfig', 'setUartConfig']),
    getDeliverDisplayName(device) {
      if (!device.deliver_id) return '未知商户';
      const info = this.merchantInfoMap[device.deliver_id] || {};
      const name = info.account_holder || device.deliver_nick_name || info.nick_name || device.deliver_name || info.name || '未知商户';
      return `[${device.deliver_id}] ${name}`;
    },
    getDeliverLocation(device) {
      const info = this.merchantInfoMap[device.deliver_id] || {};
      return info.store_address || device.location || '未知位置';
    },
async fetchMerchantInfo() {
try {
this.merchantInfoMap = await getMerchantInfoMap();
} catch (err) {
console.error("获取商户信息失败:", err);
}
},
    formattedDate(date) {
      return formatDate(date);
    },
    // 切换页码
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.fetchDevices({ page, pageSize: this.pageSize, board_id: this.searchBoardId || undefined, deliver_id: this.searchDeliverId || undefined, online: parseInt(this.searchOnline) });
      }
    },
    doSearch() {
      this.fetchDevices({ page: 1, pageSize: this.pageSize, board_id: this.searchBoardId || undefined, deliver_id: this.searchDeliverId || undefined, online: parseInt(this.searchOnline) });
    },
    resetSearch() {
      this.searchBoardId = '';
      this.searchDeliverId = '';
      this.searchOnline = '-1';
      this.fetchDevices({ page: 1, pageSize: this.pageSize });
    },

    openTestCoinModal(boardId, online, device) {
      console.log('clicked on device with board_id:', boardId, 'online:', online, 'device:', device);
      if (online !== 1 ) {
        alert('设备离线，无法测试');
        return;
      }
      this.selectedBoardId = boardId;
      this.coinCount = 1;
      this.isModalVisible = true;
      this.port = 1;
      // 如果设备有外设列表，自动选择第一个有绑定外设的端口
      if (device && device.sub_devices && device.sub_devices.length > 0) {
        const boundSub = device.sub_devices.find(sd => sd.serial_number);
        if (boundSub) {
          this.port = boundSub.uart_port || 1;
        }
      }
    },

    closeModal() {
      this.isModalVisible = false;
    },

    submitTestCoin(){
      if (this.coinCount && this.coinCount > 0) {
        console.log('port', this.port)
        this.$store.dispatch('boards/testCoinsRequest',{
          board_id: this.selectedBoardId,
          coins: (this.coinCount*100).toString(),
          port: (this.port).toString(),
        }).then((response)=>{
          console.log('response:', response);
          if (response.code === 0) {
            alert('投币测试成功, 币数:' + this.coinCount.toString());
            this.closeModal();
          }else{
            alert(response.desc || '投币测试失败');
          }
          
        }).catch((error)=>{
          console.log('投币测试失败', error);
          alert('投币测试失败，请稍后重试');
        });
      }else{
        alert('请输入有效的投币数量');
      }
    },

    handleReboot(device) {
      if (device.online !== 1) {
        alert('设备离线，无法执行远程重启');
        return;
      }
      // 确定重启端口：优先使用有绑定外设的端口
      let rebootPort = 1;
      if (device.sub_devices && device.sub_devices.length > 0) {
        const boundSub = device.sub_devices.find(sd => sd.serial_number);
        if (boundSub && boundSub.uart_port) {
          rebootPort = boundSub.uart_port;
        }
      }
      if (!confirm(`确认要对设备 ${device.board_id} (端口${rebootPort}) 执行远程重启操作吗？\n\n系统将下发重启指令并等待设备回复（最长15秒）`)) {
        return;
      }
      this.$store.dispatch('boards/rebootDeviceRequest', {
        board_id: device.board_id,
        port_id: rebootPort,
      }).then((response) => {
        if (response && response.code === 0) {
          let msg = '远程重启成功，设备已回复';
          if (typeof response.desc === 'object' && response.desc !== null) {
            const desc = response.desc;
            if (desc.status) msg += ` (状态: ${desc.status})`;
          } else if (typeof response.desc === 'string') {
            msg += ` (${response.desc})`;
          }
          alert(msg);
        } else if (response && response.code === -8) {
          alert(response.desc || '等待设备回复超时，设备可能需要手动确认重启状态');
        } else {
          alert(response && response.desc ? response.desc : '远程重启指令下发失败');
        }
      }).catch((error) => {
        console.error('远程重启失败', error);
        alert('远程重启失败，请稍后重试');
      });
    },

    handlePowerCtrl(device) {
      if (device.online !== 1) {
        alert('设备离线，无法执行开关机操作');
        return;
      }
      const action = confirm(`请确认操作：\n\n确定 = 远程开机\n取消 = 远程关机\n\n设备ID：${device.board_id}`);
      const actionVal = action ? 1 : 0;
      const actionText = action ? '开机' : '关机';
      if (!confirm(`此操作将远程${actionText}设备 ${device.board_id}，是否继续？`)) {
        return;
      }
      this.$store.dispatch('boards/powerCtrlDeviceRequest', {
        board_id: device.board_id,
        action: actionVal,
        port_id: 1,
      }).then((response) => {
        if (response && response.code === 0) {
          alert(`远程${actionText}指令已下发成功`);
        } else {
          alert(response && response.desc ? response.desc : `远程${actionText}指令下发失败`);
        }
      }).catch((error) => {
        console.error(`远程${actionText}失败`, error);
        alert(`远程${actionText}失败，请稍后重试`);
      });
    },

    handleBindHistory(device) {
      this.$store.dispatch('boards/fetchDeviceBindHistory', {
        board_id: device.board_id,
      }).then((response) => {
        if (response && response.code === 0 && Array.isArray(response.desc)) {
          const history = response.desc;
          if (history.length === 0) {
            alert(`设备 ${device.board_id} 暂无绑定历史记录`);
            return;
          }
          let msg = `设备 ${device.board_id} 绑定历史：\n\n`;
          history.forEach((h, i) => {
            const date = new Date(h.created_date * 1000);
            const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')} ${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
            const action = h.action === 'bind' ? '绑定' : '解绑';
            msg += `${i+1}. [${dateStr}] ${action} → 商户: ${h.deliver_name || h.deliver_id}\n`;
          });
          alert(msg);
        } else {
          alert(response && response.desc ? response.desc : '查询绑定历史失败');
        }
      }).catch((error) => {
        console.error('查询绑定历史失败', error);
        alert('查询绑定历史失败，请稍后重试');
      });
    },

    openFotaModal() {
      this.isFotaModalVisible = true;
      this.fotaOssName = "";
      this.fotaUrl = "";
    },

    closeFotaModal() {
      this.isFotaModalVisible = false;
    },

    confirmOssFota() {
      if (!this.fotaOssName || !this.fotaOssName.trim()) {
        alert("请输入升级包oss_name");
        return;
      }
      if (!confirm("此操作将会下发指定的升级包到客户端，务必确认设备与升级包版本。\n\n设备ID：" + this.selectedBoardIdsText + "\n升级包：" + this.fotaOssName.trim())) {
        return;
      }
      this.executeFotaSubmit("oss");
    },

    confirmUrlFota() {
      if (!this.fotaUrl || !this.fotaUrl.trim()) {
        alert("请输入固件下载URL");
        return;
      }
      if (!confirm("此操作将会下发指定的升级包到客户端，务必确认设备与升级包版本。\n\n设备ID：" + this.selectedBoardIdsText + "\n升级URL：" + this.fotaUrl.trim())) {
        return;
      }
      this.executeFotaSubmit("url");
    },

    async executeFotaSubmit(mode) {
      if (this.fotaSubmitting) {
        return;
      }
      const boardIds = [...this.selectedBoardIds];
      if (boardIds.length === 0) {
        alert("请先选择设备");
        return;
      }
      this.fotaSubmitting = true;
      try {
        let results;
        if (mode === "oss") {
          results = await Promise.allSettled(
            boardIds.map((boardId) =>
              this.$store.dispatch("boards/pushFotaRequest", {
                board_id: boardId,
                oss_name: this.fotaOssName.trim(),
              })
            )
          );
        } else {
          results = await Promise.allSettled(
            boardIds.map((boardId) =>
              this.$store.dispatch("boards/pushFotaUrlRequest", {
                board_id: boardId,
                fota_url: this.fotaUrl.trim(),
              })
            )
          );
        }
        const successIds = [];
        const failedItems = [];
        results.forEach((result, index) => {
          const boardId = boardIds[index];
          if (result.status === "fulfilled" && result.value && result.value.code === 0) {
            successIds.push(boardId);
          } else {
            const desc =
              result.status === "fulfilled"
                ? result.value && result.value.desc
                : result.reason && result.reason.message;
            failedItems.push({
              boardId,
              desc: desc || "下发失败",
            });
          }
        });
        if (failedItems.length === 0) {
          alert(`升级指令已下发成功\n成功设备：${successIds.join(", ")}`);
          this.selectedBoardIds = [];
        } else {
          const successText = successIds.length ? successIds.join(", ") : "无";
          const failedText = failedItems
            .map((item, index) => `${index + 1}. 设备 ${item.boardId}：${item.desc}`)
            .join("\n");
          alert(`升级指令完成\n成功设备：${successText}\n失败设备：\n${failedText}`);
          this.selectedBoardIds = failedItems.map((item) => item.boardId);
        }
      } catch (error) {
        console.log("升级指令下发失败", error);
        alert("升级指令下发失败，请稍后重试");
      } finally {
        this.fotaSubmitting = false;
        this.isFotaModalVisible = false;
        this.fotaOssName = "";
        this.fotaUrl = "";
      }
    },

    clearCache(){
      this.clearLocalCache().then(()=>{
        //alert('本地缓存已清理');
        this.fetchDevices();
      }).catch((error)=>{
        console.log('cache clear failed:', error);
        alert('清理缓存失败，请稍后重试');
      });
    },

    openUartModal(device) {
      this.uartBoardId = device.board_id;
      this.uartForm.uartPort = "";
      this.uartForm.baudrate = "";
      this.uartForm.baudrateList = "";
      this.isUartModalVisible = true;
      this.fetchUartConfig({ board_id: device.board_id, force: false });
    },

    closeUartModal() {
      this.isUartModalVisible = false;
    },

    toggleSubDeviceExpand(boardId) {
      const idx = this.expandedBoardIds.indexOf(boardId);
      if (idx > -1) {
        this.expandedBoardIds.splice(idx, 1);
      } else {
        this.expandedBoardIds.push(boardId);
      }
    },

    async refreshUartConfig() {
      if (!this.uartBoardId) {
        return;
      }
      if (this.uartRefreshCooling) {
        alert("请稍后再试");
        return;
      }
      try {
        const response = await this.fetchUartConfig({ board_id: this.uartBoardId, force: true });
        if (response && response.code === -6) {
          this.uartRefreshCooling = true;
          if (this.uartRefreshTimer) {
            clearTimeout(this.uartRefreshTimer);
          }
          this.uartRefreshTimer = setTimeout(() => {
            this.uartRefreshCooling = false;
            this.uartRefreshTimer = null;
            this.fetchUartConfig({ board_id: this.uartBoardId, force: false }).then((nextResponse) => {
              if (nextResponse && nextResponse.code === 0) {
                alert("配置已更新");
              }
            }).catch(() => {});
          }, 5000);
          alert("已下发查询，请稍后重试");
        } else if (response && response.code === 0) {
          this.uartRefreshCooling = true;
          if (this.uartRefreshTimer) {
            clearTimeout(this.uartRefreshTimer);
          }
          this.uartRefreshTimer = setTimeout(() => {
            this.uartRefreshCooling = false;
            this.uartRefreshTimer = null;
          }, 5000);
          alert("配置已更新");
        } else {
          alert(response && response.desc ? response.desc : "刷新失败");
        }
      } catch (error) {
        console.log("刷新配置失败", error);
        alert("刷新配置失败，请稍后重试");
      }
    },

    async submitUartConfig() {
      if (!this.uartBoardId) {
        alert("未选择设备");
        return;
      }
      const payload = {
        board_id: this.uartBoardId,
      };
      if (this.uartForm.baudrateList && this.uartForm.baudrateList.trim()) {
        payload.uartport_baud_rate_list = this.uartForm.baudrateList.trim();
      } else {
        if (!this.uartForm.baudrate) {
          alert("请输入波特率");
          return;
        }
        payload.uartport_baud_rate = this.uartForm.baudrate.toString();
        if (this.uartForm.uartPort !== "" && this.uartForm.uartPort !== null) {
          payload.uart_port = this.uartForm.uartPort.toString();
        }
      }
      try {
        const response = await this.setUartConfig(payload);
        if (response && response.code === 0) {
          alert("设置指令下发成功");
        } else {
          alert(response && response.desc ? response.desc : "设置失败");
        }
      } catch (error) {
        console.log("设置串口配置失败", error);
        alert("设置串口配置失败，请稍后重试");
      }
    },

  },
  mounted() {    
    // 读取 URL 查询参数，支持从商户详情跳转时自动过滤
    this.fetchMerchantInfo();
    const query = this.$route.query;
    if (query.board_id) {
      this.searchBoardId = String(query.board_id);
    }
    if (query.deliver_id) {
      this.searchDeliverId = String(query.deliver_id);
    }
    // 如果有查询参数，使用过滤条件获取设备；否则获取全部
    if (this.searchBoardId || this.searchDeliverId) {
      this.doSearch();
    } else {
      this.fetchDevices({ page: 1, pageSize: 20 });
    }
  },
  beforeUnmount() {
    if (this.uartRefreshTimer) {
      clearTimeout(this.uartRefreshTimer);
    }
  }
};
</script>

<style scoped>
.pagination {
  margin: 0;
}

.page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.page-item.active .page-link {
  background-color: #344767;
  border-color: #344767;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}
</style>
